import { } from './actionTypes'

function initialState( preserve = {} ) {
  return Object.assign({},{
  }, preserve )
}

export default function (state = initialState(), action) {

  console.log('App - Reducer')

  return state
}
